import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Alert } from "react-bootstrap";
import { VisualCache, UserInfo } from "../helper/Context";
import SearchComponent from "../components/SearchComponent";
import Joyride, { STATUS } from "react-joyride";
import { isMobile } from "../helper/Utils";
import DashboardBody from "./DashboardBody";
import DashboardContainer from "./DashboardContainer";
import "./DashboardPage.css";

const DashboardPage = (props) => {
  return <DashboardContainer />;
};

export default DashboardPage;
